import React, { ReactNode } from 'react';
import ReactDOM from 'react-dom';
import getI18N from '../../lib/i18n';
import Button from '../Button/Button';
import styles from './Modal.module.scss';

interface ModalProps {
    isOpen: boolean;
    onClose: () => void;
    children: ReactNode;
}

const i18n = getI18N();
const Modal: React.FC<ModalProps> = ({ isOpen, onClose, children }) => {
    if (!isOpen) {
        return null;
    }

    const handleModalClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
        e.stopPropagation();
    };

    return ReactDOM.createPortal(
        <div className={styles['modal-overlay']}>
            {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events */}
            <div className={styles.modal} onClick={handleModalClick}>
                <div className={styles['modal-content']}>{children}</div>
                <div className={styles['modal-footer']}>
                    <Button
                        className={styles['modal-confirm']}
                        onClick={onClose}
                        type="button"
                        text={i18n('widgetgenerator.modal.continue')}
                    />
                </div>
            </div>
        </div>,
        document.body
    );
};

export default Modal;
